import { render, staticRenderFns } from "./myEmail.vue?vue&type=template&id=2df748d4&scoped=true&"
import script from "./myEmail.vue?vue&type=script&lang=js&"
export * from "./myEmail.vue?vue&type=script&lang=js&"
import style0 from "./myEmail.vue?vue&type=style&index=0&id=2df748d4&prod&lang=less&scoped=true&"
import style1 from "./myEmail.vue?vue&type=style&index=1&id=2df748d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df748d4",
  null
  
)

export default component.exports